import { useEffect } from 'react';

const CriticalStylesDefer = () => {
  useEffect(() => {
    // Defer loading of non-critical CSS after initial render
    const deferStyles = () => {
      const nonCriticalStyles = [
        '/static/css/swiper.css',
        '/static/css/animations.css'
      ];

      nonCriticalStyles.forEach(href => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.media = 'print';
        link.onload = function() {
          this.media = 'all';
        };
        document.head.appendChild(link);
      });
    };

    // Defer until after initial paint
    if ('requestIdleCallback' in window) {
      requestIdleCallback(deferStyles);
    } else {
      setTimeout(deferStyles, 100);
    }
  }, []);

  return null;
};

export default CriticalStylesDefer;